import { render, staticRenderFns } from "./SmartGrabberManagement.vue?vue&type=template&id=3c27e0e9&scoped=true&"
import script from "./SmartGrabberManagement.vue?vue&type=script&lang=js&"
export * from "./SmartGrabberManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c27e0e9",
  null
  
)

export default component.exports